/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Extraction_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Audio extraction in progress..." |
*
* @param {Audio_Extraction_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_extraction_in_progress = /** @type {((inputs?: Audio_Extraction_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Extraction_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction audio en cours...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioextraktion läuft...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione audio in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Процесс извлечения аудиофайлов продолжается...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extracción de audio en progreso...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频提取正在进行中……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ抽出中です...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो निकालने की प्रक्रिया जारी है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extração de áudio em andamento...")
	return /** @type {LocalizedString} */ ("Audio extraction in progress...")
});